module.exports = __webpack_public_path__ + "static/media/VolumeBoxIconActive.10b60c60.png";